// todo move this file to module
export const gateStatus = {
    '1': 'آزمایشی',
    '0': 'غیرآزمایشی',
}
